<template>
	<div class="Mine">
		<div class="back-btn" @click="$router.back()">
			<img src="../assets/img/back.png" />
			<span>返回</span>
		</div>


		<div class="alert">
			<div class="table">
				<span class="col-8">时间</span>
				<span class="col-8">奖品</span>
				<span class="col-8">地址</span>
				<div style="height: 50%;overflow-y: scroll;">
					<span class="col-24 border-bottom" v-for="item in LotteryRecordList" :key="item.id">
						<span class="col-8">{{item.createTime}}</span>
						<span class="col-8">{{item.awardName}}</span>
						<span class="col-8" v-show="item.awardType==0">公测日发放</span>
						<span class="col-8" v-show="item.awardType!=0&&item.address"
							@click="addressUpdate(item)">{{item.address}}</span>
						<span class="col-8" v-show="item.awardType!=0&&!item.address"
							@click="addressUpdate(item)">编辑</span>
					</span>

				</div>
			</div>

			<span class='tip'> 请中奖玩家在2022年2月10日23:59之前填写个人信息否则视为自动放弃奖品</span>
		</div>
		<div class="btn-submit" @click="logOut">登 出</div>
		<div class="btn-gift" @click="gift">{{received?'已领取奖励':'领取奖励'}}</div>
	</div>
</template>

<script>
	export default {
		name: "mine",
		data() {
			return {
				LotteryRecordList: [],
				received: true,
			}
		},
		created() {
			this.getLotteryRecord()
		},
		watch: {
			accessToken(cv) {
				if (cv) {
					this.getLotteryRecord()
				}
				localStorage.setItem('accessToken', cv)
			}
		},
		computed: {
			accessToken() {
				return this.$store.getters.accessToken
			}
		},
		methods: {
			async getLotteryRecord() {
				let res = await this.$store.dispatch('getLotteryRecord', {})
				if (this.$Api.ok(res)) {
					this.LotteryRecordList = res[0].data.data
					this.LotteryRecordList.forEach(item => {
						if (item.receiveFlag == 0) {
							this.received = false
						}
					})
				}
			},
			addressUpdate(item) {
				if (item.awardType == 0) {
					return this.$Toast.show('虚拟物品，无需收货地址')
				}
				this.$Address.show(item, () => {
					this.getLotteryRecord()
				})
			},
			logOut() {
				this.$Confirm.show('确认退出？', () => {
					this.$store.commit('SET_ACCESS_TOKEN', '')
					this.$router.back()
				})

			},
			gift() {
				if (this.received&&this.accessToken) {
					return this.$Toast.show('已领取奖励')
				}
				this.$ServerRole.show(async (form) => {
					if (!form.roleId || !form.serverId) {
						return this.$Toast.show('请选择区服角色')
					}
					let res = await this.$store.dispatch('exchangeLottery', {
						roleId: form.roleId,
						serverId: form.serverId,
					})
					if (this.$Api.ok(res)) {
						this.received = true
						this.$Toast.show('领取成功')
					}
				})

			}
		},
	};
</script>
<style scoped>
	.Mine {
		width: 100%;
		height: 100%;
		background: url(../assets/img/bg.png);
		background-position: center center;
		background-repeat: no-repeat;
		background-size: cover;
		overflow-y: scroll;
	}

	.back-btn {
		height: 30px;
		float: left;
		margin-left: 10px;
		margin-top: 60px;
		width: 300px;
	}

	.back-btn img {
		display: block;
		float: left;
		height: 100%;
		padding-right: 10px;
	}

	.back-btn span {
		display: block;
		line-height: 30px;
		height: 100%;
		font-size: 16px;
		font-weight: 600;
		color: #8d6045;
	}

	.alert {
		width: 100%;
		height: 70%;
		background: url(../assets/img/mine/alert.png);
		background-position: center center;
		background-repeat: no-repeat;
		background-size: contain;
		position: fixed;
		bottom: 90px;
		display: flex;
		justify-content: space-around;
	}

	.btn-submit {
		width: 50%;
		height: 40px;
		background: url(../assets/img/mine/btn-bg.png);
		background-position: center center;
		background-repeat: no-repeat;
		background-size: contain;
		position: fixed;
		bottom: 30px;
		left: 0;
		text-align: center;
		line-height: 40px;
		color: #8d6045;
	}

	.btn-gift {
		width: 50%;
		height: 40px;
		background: url(../assets/img/home/appoint-btn.png);
		background-position: center center;
		background-repeat: no-repeat;
		background-size: contain;
		position: fixed;
		bottom: 30px;
		right: 0;
		text-align: center;
		line-height: 40px;
		color: #8d6045;
	}

	.table {
		width: 100%;
		color: #8d6045;
		vertical-align: middle;
		padding: 10px 40px;
		margin-top: 180px;
	}

	.col-8 {
		display: inline-block;
		width: 33.33%;
		text-align: center;
		padding-bottom: 10px;
	}

	.tip {
		display: inline-block;
		position: fixed;
		bottom: 100px;
		padding: 50px;
		color: #8d6045;
	}

	.border-bottom {
		padding-bottom: 4px;
		border-bottom: 1px solid #8d6045;
	}
</style>
